export default __webpack_public_path__ + "static/media/safari_settings_partial.209a371a.png";